module.exports = __webpack_public_path__ + "mo/media/MO_about_time_lapse.1a2597ad.mp4";